import { ContactUsDefault } from 'src/components/features';

const ContactUs = () => <ContactUsDefault />;

export default ContactUs;
